import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import {getShanxiToken, getToken} from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL:'https://api.xiyilab.com/v1', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    //config.headers['Content-Type']='application/json'
    //console.log(config)
    if(getToken()||getShanxiToken()){
      // console.log(getShanxiToken())
      let str=getToken()?getToken():getShanxiToken()
      config.headers['Authorization']='Bearer '+str
      // console.log(config)
    }
    return config
  },
  error => {
    // do something with request error
    //console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    // if(response.data.status==='ok'){
    //   response.status=200
    // }
    // const res = response.data
    // if(process.client){
    //   //console.log(res)
    // }
    //console.log(response)
    // if(response.data.status==='no'&&response.data.message==='无权访问')
    // {
    //   Message({
    //     message: response.data.message,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    // }
    // else{
    //
    // }
    return response.data
    // if the custom code is not 20000, it is judged as an error.
    // if (res.status==='no') {
    //   Message({
    //     message: res.message || 'Error:status no',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //
    //   return res
    // }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: '网络连接超时，请稍后重试',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
